import React, { useEffect } from "react";
import { Renderhamburgermenu } from "../../hamburger/hamburger-menu";
import myAssessmentIcon from "../../../../images/new-images/bulb-orange.svg";
import Renderassessmentquestions from "./questions";
import Responsiveassessmentquestions from "../begin-questionnaire/responsive/responsive-assessment-questions";

export const Rendermastercomponent = (props) => {
  const calcWidth = window.innerWidth;


  let portrait = window.matchMedia("(orientation: portrait)");
  let maxWidth = window.matchMedia("(max-width: 667px)")

  // app will auto reload when user change the width size , like mobile screen rotation from potrain to lanscap vice-versa
  portrait.addEventListener("change", function (e) {

    if (e.matches) {
      window.location.reload()
    } else {
      window.location.reload()
    }
  })
  maxWidth.addEventListener("change", function (e) {
    if (e.matches) {
      window.location.reload()
    } else {
      window.location.reload()
    }
  })

  return (
    <React.Fragment>
      {calcWidth <= 668 ? (
        <Responsiveassessmentquestions
          myAssessmentIcon={myAssessmentIcon}
          text="Assessment"
          reviewText="Review Assessment"
          defaultQuestionNumber={props.defaultQuestionNumber}
          handleQuestionNumber={props.handleQuestionNumber}
          defaultQuestion={props.defaultQuestion}
          value={props.value}
          handleInputRange={props.handleInputRange}
          handleGoToNext={props.handleGoToNext}
          handleAssessmentSubmit={props.handleAssessmentSubmit}
          handlePrevToNext={props.handlePrevToNext}
          assessmentModal={props.assessmentModal}
          handleModalClose={props.handleModalClose}
          handleModalSubmit={props.handleModalSubmit}
          nestedModal={props.nestedModal}
          values={props.values}
          reviewMode={props.reviewMode}
          handleReviewAssessment={props.handleReviewAssessment}
          isPopOverVisible={props.isPopOverVisible}
          overlayIsVisible={props.overlayIsVisible}
          handleReviewPopOver={props.handleReviewPopOver}
          handleCloseReviewPopOver={props.handleCloseReviewPopOver}
          handleReviewAssessmentSubmit={props.handleReviewAssessmentSubmit}
          handleSaveAndContinue={props.handleSaveAndContinue}
          touched={Boolean(props.values[props.defaultQuestionNumber])}
          defaultColor={props.defaultColor}
          questionNumber={props.questionNumber}
          questionList={props.questionList}
          instrumentOptions={props.instrumentOptions}
          currentQuestion={props.currentQuestion}
          instrumentType={props.instrumentType}
          runningQuestionId={props.runningQuestionId}
          uid={props.uid}
          assessmentType={props.assessmentType}
          invitationDetails={props.invitationDetails}
          participant_gender={props.participant_gender}
          participantId={props.participantId}
          isMultiRater={props.isMultiRater}
          min_batch_respondents={props.min_batch_respondents}
        />
      ) : (
        <section className="dashboard-wrapper">
          <div className="content-center-align">
            <Renderhamburgermenu
              link1="/new/app/dashBoard"
              link2="/new/app/questionnaire"
              text1="Dashboard"
              text2="Assessment"
              reviewMode={props.reviewMode}
            />
            <Renderassessmentquestions
              myAssessmentIcon={myAssessmentIcon}
              text="Assessment"
              reviewText="Review Assessment"
              defaultQuestionNumber={props.defaultQuestionNumber}
              handleQuestionNumber={props.handleQuestionNumber}
              defaultQuestion={props.defaultQuestion}
              value={props.value}
              handleInputRange={props.handleInputRange}
              handleGoToNext={props.handleGoToNext}
              handleAssessmentSubmit={props.handleAssessmentSubmit}
              assessmentModal={props.assessmentModal}
              handleModalClose={props.handleModalClose}
              handleModalSubmit={props.handleModalSubmit}
              nestedModal={props.nestedModal}
              values={props.values}
              reviewMode={props.reviewMode}
              handleReviewAssessment={props.handleReviewAssessment}
              isPopOverVisible={props.isPopOverVisible}
              overlayIsVisible={props.overlayIsVisible}
              handleReviewPopOver={props.handleReviewPopOver}
              handleCloseReviewPopOver={props.handleCloseReviewPopOver}
              handleReviewAssessmentSubmit={props.handleReviewAssessmentSubmit}
              handleSaveAndContinue={props.handleSaveAndContinue}
              touched={Boolean(props.values[props.defaultQuestionNumber])}
              defaultColor={props.defaultColor}
              questionNumber={props.questionNumber}
              questionList={props.questionList}
              instrumentOptions={props.instrumentOptions}
              currentQuestion={props.currentQuestion}
              instrumentType={props.instrumentType}
              runningQuestionId={props.runningQuestionId}
              uid={props.uid}
              assessmentType={props.assessmentType}
              invitationDetails={props.invitationDetails}
              participant_gender={props.participant_gender}
              participantId={props.participantId}
              isMultiRater={props.isMultiRater}
              min_batch_respondents={props.min_batch_respondents}
              myRef={props.myRef}
            />
          </div>
        </section>
      )}
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/master.jsx